import { render, staticRenderFns } from "./SearchComponent.html?vue&type=template&id=04260c58&scoped=true&"
import script from "./SearchComponent.js?vue&type=script&lang=js&"
export * from "./SearchComponent.js?vue&type=script&lang=js&"
import style0 from "./SearchComponent.scss?vue&type=style&index=0&id=04260c58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04260c58",
  null
  
)

export default component.exports